import { render, staticRenderFns } from "./LessonBuilderLayoutSection.vue?vue&type=template&id=0bf1d0a0&scoped=true&"
import script from "./LessonBuilderLayoutSection.vue?vue&type=script&lang=js&"
export * from "./LessonBuilderLayoutSection.vue?vue&type=script&lang=js&"
import style0 from "./LessonBuilderLayoutSection.vue?vue&type=style&index=0&id=0bf1d0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf1d0a0",
  null
  
)

component.options.__file = "LessonBuilderLayoutSection.vue"
export default component.exports